import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "py-2.5 px-3 rounded-lg shadow-lg bg-white mb-2" }
const _hoisted_2 = { class: "flex justify-start h-10" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "flex-grow ml-1" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "flex justify-between flex-grow" }
const _hoisted_7 = { class: "ml-1 text-gray-500" }
const _hoisted_8 = { class: "text-xs text-gray-400" }
const _hoisted_9 = { class: "text-left" }
const _hoisted_10 = { class: "mr-1 text-xs text-gray-500" }
const _hoisted_11 = { class: "mr-1 text-xs text-gray-500" }
const _hoisted_12 = { class: "mr-1 text-xs text-gray-500" }
const _hoisted_13 = { class: "mt-2 mb-2 text-sm text-left text-gray-600 whitespace-pre-wrap" }
const _hoisted_14 = {
  key: 0,
  class: "h-9"
}
const _hoisted_15 = {
  key: 1,
  class: "w-screen h-1"
}
const _hoisted_16 = { class: "flex justify-around h-3 text-gray-500" }
const _hoisted_17 = { class: "ml-1 text-xs" }
const _hoisted_18 = { class: "ml-1 text-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_five_stars = _resolveComponent("five-stars")!
  const _component_reaction = _resolveComponent("reaction")!
  const _component_f_icon = _resolveComponent("f-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "w-10",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClickAvatar && _ctx.handleClickAvatar(...args)), ["stop"]))
      }, [
        _createElementVNode("img", {
          class: "w-10 h-10 rounded-full",
          src: _ctx.processAvatar(_ctx.rating.creator.avatar)
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createElementVNode("span", {
                class: "font-extrabold cursor-pointer text-primary",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClickAvatar && _ctx.handleClickAvatar(...args)), ["stop"]))
              }, _toDisplayString(_ctx.rating.creator.nickname), 1),
              _createVNode(_component_five_stars, {
                score: _ctx.rating.form.recommended,
                size: "12",
                class: "inline ml-1",
                style: {"display":"inline-flex"}
              }, null, 8, ["score"]),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.rating.form.recommended.toFixed(1)), 1)
            ]),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.timeDiff), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.mapScoreToText('difficulty', _ctx.rating.form.difficulty)), 1),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.mapScoreToText('nice', _ctx.rating.form.nice)), 1),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.mapScoreToText('workload', _ctx.rating.form.workload)), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.rating.form.content), 1),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createVNode(_component_reaction, {
            value: _ctx.mockReaction,
            readonly: false,
            onAdd: _ctx.handleAddReaction,
            onDelete: _ctx.handleDeleteReaction
          }, null, 8, ["value", "onAdd", "onDelete"])
        ]))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_15))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_16, [
      (_ctx.showChat)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClickChat && _ctx.handleClickChat(...args)), ["stop"]))
          }, [
            _createVNode(_component_f_icon, {
              name: "chat",
              size: "14"
            }),
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.rating.commentCount), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showLike)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClickLike && _ctx.handleClickLike(...args)), ["stop"]))
          }, [
            _createVNode(_component_f_icon, {
              name: "heart",
              size: "14",
              class: "f-clickable"
            }),
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.rating.starCount), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showEdit)
        ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClickEdit && _ctx.handleClickEdit(...args)), ["stop"]))
          }, [
            _createVNode(_component_f_icon, {
              name: "edit-square",
              size: "14",
              class: "f-clickable"
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.showDelete)
        ? (_openBlock(), _createElementBlock("span", {
            key: 3,
            onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClickDelete && _ctx.handleClickDelete(...args)), ["stop"]))
          }, [
            _createVNode(_component_f_icon, {
              name: "delete",
              size: "14",
              class: "f-clickable"
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}